// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-fwwgl-zzbd-index-main_right_content-Zh9i_","table":"components-fwwgl-zzbd-index-table-2XDM8"};


//////////////////
// WEBPACK FOOTER
// ./components/fwwgl/zzbd/index.css
// module id = 1917
// module chunks = 0